import { Brain, ChartLineUp, ChartPolar, ChatCircleText, Coins, Compass, CompassRose, Copy, Crown, DeviceMobile, DiscordLogo, Dna, Exam, File, FileText, Fire, Flask, Footprints, Gear, GraduationCap, HandCoins, HandDeposit, Headset, Heart, Heartbeat, ListStar, MapTrifold, Megaphone, Pen, PenNib, Question, Robot, Rocket, RocketLaunch, ShootingStar, Star, Student, Target, TestTube, Trophy, WarningCircle, WhatsappLogo, } from "@phosphor-icons/react";
export const ICONS = {
    bullhorn: Megaphone,
    "chart-line-up": ChartLineUp,
    cog: Gear,
    compass: Compass,
    copy: Copy,
    crown: Crown,
    "dollar-sign": Coins,
    "fab discord": DiscordLogo,
    "fab whatsapp": WhatsappLogo,
    "fas exclamation-circle": WarningCircle,
    file: File,
    "file-invoice-dollar": HandCoins,
    "graduation-cap": GraduationCap,
    "hand-paper": HandDeposit,
    headset: Headset,
    message: ChatCircleText,
    mobile: DeviceMobile,
    pen: Pen,
    robot: Robot,
    rocket: Rocket,
    "shoe-prints": Footprints,
    trophy: Trophy,
    exam: Exam,
    "test-tube": TestTube,
    "file-text": FileText,
    question: Question,
    flask: Flask,
    "rocket-launch": RocketLaunch,
    fire: Fire,
    "list-star": ListStar,
    "shooting-star": ShootingStar,
    "compass-rose": CompassRose,
    heartbeat: Heartbeat,
    "chart-polar": ChartPolar,
    dna: Dna,
    "pen-nib": PenNib,
    student: Student,
    brain: Brain,
    heart: Heart,
    target: Target,
    star: Star,
    "map-trifold": MapTrifold,
};
//# sourceMappingURL=Icons.js.map